import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  contentWrapper: {
    marginTop: 40,
    marginLeft: 53,
    marginRight: 53,
  },
  bigTitleLabel: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 700,
    marginBottom: 10,
    marginLeft: 53,
    marginRight: 53,
  },
  boldText: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 700,
    marginBottom: 10,
  },
  text: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,

    marginTop: 20,
    marginBottom: 20,
    marginLeft: 53,
    marginRight: 53,
  },
  button: {
    borderRadius: '4px',
    fontFamily: 'Lato',
    fontSize: 9,
    paddingVertical: 6,
    paddingHorizontal: 30,
    textDecoration: 'none',
    width: 'auto',
  },
  voucherImage: {
    width: '100%',
    height: 345,
    objectFit: 'cover',
  },
});
